import { render, staticRenderFns } from "./individual_gametime_manage.vue?vue&type=template&id=6b7d0546&scoped=true&"
import script from "./individual_gametime_manage.vue?vue&type=script&lang=js&"
export * from "./individual_gametime_manage.vue?vue&type=script&lang=js&"
import style0 from "./individual_gametime_manage.vue?vue&type=style&index=0&id=6b7d0546&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7d0546",
  null
  
)

export default component.exports